import BaseViz from './BaseViz'
import TreemapChart from '../charts/TreemapChart'
import PieDataController from '../viz_behaviors/TreemapDataController'
export default class TreemapViz extends BaseViz {
  static chartClass = TreemapChart
  static dataControllerClass = PieDataController
  static defaultConfig = {
    LegendBehavior: {
      showLegend: {
        value: false,
      },
      interactive: {
        nonEditable: true,
        exposed: false,
      },
    },
    ItemsHelper: {
      colorScale: {
        type: [String, Function, Array],
        default: 'categorical',
        options: ['categorical', 'sequential2', 'sequential3'],
        exposed: true,
      },
      colorKey: function (d) {
        return this.colorScale === 'categorical' ? d.parentId : d.value
      },
      // colorScale: {
      //   value: {
      //     scaleSteps: 5,
      //     interpolationType: 'linear',
      //     scaleOption: 'gradient',
      //     opacityMapValue: 100,
      //     colorRange: ['#BBD6E8', '#15537E'],
      //     customSteps: null,
      //   },
      // },
      // colorKey: 'value',
    },
    valueFormat: {
      type: [String, Array, Function, null],
      default: null,
    },
    unit: {
      type: [String, Boolean, null],
      default: false,
    },
  }
}
